import React from "react";
import MuiRow from "@material-ui/core/TableRow";
import withStyles from "../../../styles/withStyles";

function Row(props) {
  return <MuiRow {...props} />;
}

let styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    height: "48px"
  },
  hover: {
    "&$hover:hover": {
      backgroundColor: theme.palette.primary.hover
    }
  },
  head: {
    height: "40px",
    "&$hover:hover": {
      backgroundColor: "transparent"
    }
  },
  footer: {
    height: "40px",
    "&$hover:hover": {
      backgroundColor: "transparent"
    }
  }
});

Row.defaultProps = Object.assign({}, Row.defaultProps, {
  hover: true
});

export default withStyles(styles)(Row);
